import React from 'react';
import { $Formutil, connect, EasyField } from 'react-antd-formutil';
import FileUploader, { IFileUploaderProps } from 'components/FileUploader';
import classlist from 'utils/classlist';
import { IUploaderType } from './types';

export interface FileItemType {
    url: string;
    name: string;
    file?: File;
}

export interface IUploaderProps {
    isUploadFile?: boolean;
    type: IUploaderType;
    isRequired?: boolean;
    requiredMsg?: string;
    name: string;
    onDelete?: () => void;
    onAdd?: () => void;
    hasError?: boolean;
    $formutil: $Formutil;
    bucket: IFileUploaderProps['bucket'];
    defaultValue?: FileItemType;
}

const Uploader: React.FC<IUploaderProps> = ({
    isUploadFile,
    type,
    isRequired,
    requiredMsg = __('请上传文件'),
    name,
    onDelete,
    onAdd,
    hasError,
    $formutil,
    bucket,
    defaultValue
}) => {
    const handleChange = (url: FileItemType['url'], name: FileItemType['name'], file: FileItemType['file']) => {
        const data: FileItemType = { url, name };

        if (isUploadFile) {
            data.file = file;
        }

        $formutil.$setValues(data);

        onAdd?.();
    };

    return (
        <div className={classlist('uploader-component', hasError ? 'review-error' : '')}>
            <EasyField type="hidden" key="name" name="name" />
            <EasyField
                type="hidden"
                key="url"
                name="url"
                validMessage={{ required: requiredMsg }}
                required={isRequired}
            />
            {isUploadFile && <EasyField type="hidden" name="file" />}
            <FileUploader
                bucket={bucket}
                onDelete={onDelete}
                name={name}
                onSuccess={handleChange}
                type={type}
                defaultValue={defaultValue}
            />
        </div>
    );
};

export default connect(Uploader);
